<div class="setup-shell d-flex flex-column">
  <header class="setup-wizard__head">
    <div class="setup-wizard__intro text-center">
      <h1 class="m-0">{{ 'onboarding.setup.stepper.title' | translate }}</h1>
      <p class="m-0">{{ 'onboarding.setup.stepper.subtitle' | translate }}</p>
    </div>

    <nav class="setup-stepper">
      @for (step of steps; track step.id; let i = $index; let isLast = $last) {
      <div
        class="setup-stepper__node"
        [class.is-done]="stepStatus(i) === 'done'"
        [class.is-active]="stepStatus(i) === 'active'"
      >
        <div class="setup-stepper__indicator">
          @if (stepStatus(i) === 'done') {
          <mat-icon class="icon-sm">check</mat-icon>
          } @else {
          <mat-icon class="icon-sm">{{ step.icon }}</mat-icon>
          }
        </div>
        <span class="setup-stepper__label">{{ step.label | translate }}</span>
      </div>
      @if (!isLast) {
      <div class="setup-stepper__line" [class.is-done]="stepStatus(i) === 'done'"></div>
      }
      }
    </nav>
  </header>

  <div class="setup-shell__body flex-fill">
    <av-content-container [fullHeight]="true">
      <div class="setup-wizard__content">
        @if (configLoaded) {
        <router-outlet />
        } @else {
        <div
          class="setup-wizard__loader d-flex flex-column align-items-center justify-content-center py-5 gap-3"
        >
          <mat-spinner diameter="40"></mat-spinner>
          <p class="text-body-secondary mb-0">
            {{ 'onboarding.setup.stepper.loadingConfig' | translate }}
          </p>
        </div>
        }
      </div>
    </av-content-container>
  </div>
</div>

<img
  src="/assets/icons/avyna/logo.svg"
  [alt]="'onboarding.shared.logoAlt' | translate"
  class="setup-chrome__logo"
/>

<av-language-dropdown class="setup-chrome__lang"></av-language-dropdown>

<div class="setup-chrome__footer">
  <app-theme-toggle></app-theme-toggle>
  <p class="setup-chrome__version m-0">
    {{ 'onboarding.auth.shell.version' | translate: { version: version } }}
  </p>
</div>
